module.exports = __webpack_public_path__ + "img/logo_header.86389428.png";